import { withRouter } from "../../components/withRouter";
import { withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import { withToast } from "../../App";
import CustomComponent from "../../components/customComponent";
import { DefaultLayout } from "../../components/Layouts";
import { FormSelect } from "../../components/FormComponents";
import LoadingOverlay from "../../components/LoadingOverlay";

class CancelReservation extends CustomComponent {
    constructor(props) {
        super(props);
        this.state = {
            distribution: {
                reservation: "",
            },
            formIsValid: false,
            reservations: [],
            isLoading: false,
        };
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this._isMounted && this.getReservations();
        this.setState({ isLoading: false });
    }

    async getReservations() {
        let url = "/reservation/";
        let method = "GET";
        let data = await this.request(url, method);
        if (data && data.reservations) {
            this._isMounted &&
                this.setState({ reservations: data.reservations });
        } else {
            this.setState({ isActive: false });
        }
    }

    checkFormValidity() {
        const isValid = this.state.distribution.reservation !== "";

        this.setState({ formIsValid: isValid });
    }

    async onSubmit(e) {
        const { t } = this.props;
        e.preventDefault();
        this.setState({ isLoading: true });
        let url = "/reservation/unbook/" + this.state.distribution.reservation;
        let method = "POST";
        let csrf = await this.getCsrfToken("/reservation/csrf");
        let body = JSON.stringify({
            _csrf_token: csrf,
        });
        let data = await this.request(url, method, body);
        if (data && data.status === "ok") {
            this.props.addToast(
                t("Connector reservation canceled successfully"),
                {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 4000,
                },
            );
        }
        this.setState({ isLoading: false });
    }

    render() {
        const { t } = this.props;

        return (
            <DefaultLayout>
                <LoadingOverlay
                    active={this.state.isLoading}
                    spinner
                    text={t("loading")}
                />
                <h1 className="main-title">{t("remote_operations")}</h1>
                <div className="primary-form">
                    <form onSubmit={(e) => this.onSubmit(e)}>
                        <h2 className="primary-form__title">
                            {t("cancel_a_reservation")}
                        </h2>
                        <hr className="form-divider form-divider--big" />
                        <div className="row">
                            <div className="col-12">
                                <FormSelect
                                    required
                                    id="reservation"
                                    name="reservation"
                                    label={t("reservation")}
                                    value={this.state.distribution.reservation}
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "distribution",
                                            () => this.checkFormValidity(),
                                        )
                                    }
                                    options={this.state.reservations.map(
                                        (c) => ({
                                            value: c.id,
                                            name: `${c.connector.terminal.cpoTerminalId} - ${t(c.connector.fluidType)} - ${c.connector.position}`,
                                        }),
                                    )}
                                />
                            </div>
                        </div>
                        <div className="primary-form__buttons primary-form__buttons--right">
                            <button
                                type="submit"
                                disabled={!this.state.formIsValid}
                                className="vnf-btn vnf-btn-primary vnf-btn-m vnf-btn-similar-color vnf-btn-bleu-a2 vnf-btn-box-shadow-bleu-a4"
                            >
                                {t("send")}
                            </button>
                        </div>
                        <p className="primary-form__required-fields">
                            * {t("required_fields")}
                        </p>
                    </form>
                </div>
            </DefaultLayout>
        );
    }
}

export default withToast(
    hoistStatics(
        withTranslation()(withRouter(CancelReservation)),
        CancelReservation,
    ),
);
